export const credentials_index = ['credentials.index']
export const credentials_create = ['credentials.create']
export const credentials_edit = ['credentials.edit']

export default [].concat(
    credentials_index,
    credentials_create,
    credentials_edit
)
